import environment from "./BaseEnvironment";

const baseUrl = "https://dev.epona.upquai.com/";      // URL to run the application (HOST & PORT)
const baseApi = "https://dev.webservice.epona.upquai.com/api"; // Test API
// const baseUrl = "http://localhost:4200/api"; // URL of Localhost
// const baseApi = "http://localhost:8000/api"; // URL of Local server
const APP_ENVIRONMENT = "eponaDevelopment"
const enableItemClassification = true;


const env = environment(baseApi);

const TestEnvironment = {
  ...env,
  baseUrl: baseUrl,
  baseApi: baseApi,
  APP_ENVIRONMENT : APP_ENVIRONMENT,
  enableItemClassification: enableItemClassification

};

export default TestEnvironment;
